import { Table } from 'antd';
import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { ApiClient } from '../../api';
import { getStreaks } from '../../api/queries';
import { DrawerLayout } from '../../Layout';
import queryClient from '../../store/queryClient';
import { columns } from './data';

const StreaksComponent = () => {
    const { isFetching, data } = useQuery('streaks', getStreaks);
    const [loading, setLoading] = React.useState(false);
    const [updateValue, setUpdateValue] = React.useState<any>({});

    const callAPIToUpdateValue = () => {
        setLoading(true);
        ApiClient.updateStreak({
            milestones: updateValue.milestones,
        })
            .then(() => {
                ApiClient.showSuccess('Milestones successfully updated');
                setUpdateValue({});
                setLoading(false);
            })
            .catch(() => {
                ApiClient.showError('Something went wrong');
                setUpdateValue({});
                setLoading(false);
            });
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            if (updateValue.milestones) {
                callAPIToUpdateValue();
            }
        }, 1500);
        return () => clearTimeout(timer);
    }, [updateValue]);

    const updateInputValue = (value: any, record: any, key: string) => {
        setUpdateValue({
            ...data,
            milestones: data.milestones.map((item: any) => {
                if (item.milestoneDay === record.milestoneDay) {
                    return { ...item, [key]: value };
                }
                return item;
            }),
        });
        queryClient.setQueryData('streaks', (old: any) => {
            return {
                ...old,
                milestones: old.milestones.map((item: any) => {
                    if (item.milestoneDay === record.milestoneDay) {
                        return { ...item, [key]: value };
                    }
                    return item;
                }),
            };
        });
    };

    return (
        <DrawerLayout>
            <Table
                loading={isFetching || loading}
                rowKey={'milestoneDay'}
                columns={columns(updateInputValue)}
                dataSource={data?.milestones ?? []}
                locale={{ emptyText: 'No Streaks' }}
            />
        </DrawerLayout>
    );
};

export default StreaksComponent;
